module.exports = __webpack_public_path__ + "media/images/exp-two-205382836eb69d53ade550769c284fec.png";